import dayjs from 'dayjs';

/**
 * Hook to get current datetime in UTC format
 * @returns Current datetime string in format: YYYY-MM-DDTHH:mm:ss.SSS[Z]
 */
export default function useCurrentDateTime(): string {
  return dayjs().utcOffset(0, true).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
}
